import {stringify} from 'qs'
import {format} from 'utils'
import api from 'app-self-support-order/common/api/order-manage'
import request from 'app-self-support-order/utils/request'

// 获取店铺列表
export async function getOrderList(params) {
    return request(`${api.getOrderList.url}?${stringify(params)}`)
}

export async function getOrderDetails(payload) {
    return request(
        format(`${api.getOrderDetails.url}?${stringify(payload.params)}`, {
            order_no: payload.order_no,
        }),
    )
}

// 解除绑定
export async function unBind(payload) {
    return request(format(api.unBind.url, {external_userid: payload.external_userid}), {
        method: api.unBind.type,
        body: payload.body,
    })
}
